module.exports = true;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_library.js
// module id = 165
// module chunks = 15 16